export const ApiType = {
  POST_METHOD : "POST",
  GET_METHOD :"GET",
  SIGN_IN: "signIn",
  BASIC_AUTH: "basicAuth",
  AUTH_TOKEN: "authToken",
  GET_PAYOUT_DETAILS: "getPayoutDetail",
  GET_PAYOUT_SUMMARY: "getPayoutSummary",
  ON_HOLD_DETAILS: "onHoldDetails",
  ON_HOLD_SUMMARY: "onHoldSummary",
  ADD_FREEZED_ACCOUNT: "/freezeAccount/addFreezeAccountDetails",
  GET_ATTACHMENT_INFO: "/attachments/getAttachment",
  GET_PAYOUT_ERROR_DETAILS: "/payout/getPayoutPostErrors",
  GET_FREEZED_ACCOUNT_COUNT: "/freezeAccount/getFreezeAccountCount",


  
  // dashboard
  GET_COUNT_HEADER: "getCountHeader",
  ON_HOLD_PAYOUT_COMMISSION_TYPE: "onHoldPayoutCommissionType",

  // payout 
  PAYOUT_TOTAL_HEADER_SUMMARY : "payoutTotalHeaderSummary",
  PAYOUT_DEALER_HEADER_SUMMARY: "payoutDealerHeaderSummary",
  GET_PAYOUT_SUMMARY_TRANSACTION_TYPE: "getPayoutSummaryTransType",
  GET_PAYOUT_SUMMARY_DEALER: "getPayoutSummaryDealer",
  REQUEST_APPROVAL_PAYOUT: "requestApprovalPayout",
  APPROVE_PAYOUT: "approvePayout",
  HOLD_PAYOUT_TRANSACTION_TYPE: "holdPayoutTransactionType",
  HOLD_PAYOUT_COMPANY_CODE: "holdPayoutCompanyCode",
  HOLD_PAYOUT_TRANSACTIONS: "holdPayoutTransactions",
  GET_ALL_PAYOUT_LIST: "getAllPayoutList",
  GET_PAYOUT_ACTIVITY_DETAILS: "getPayoutActivityDetails",
  
  // on hold
  ON_HOLD_HEADER_SUMMARY: "onHoldHeaderSummary",
  ON_HOLD_COMPANY_DETAILS: "onHoldCompany",
  ON_HOLD_ACTIVITY_DETAILS: "getHoldActivityDetail",
  ON_HOLD_DYNAMIC_HEADER_SUMMARY: "onHoldDynamicHeaderSummary",

  ON_HOLD_CANCEL_CYCLE: "/ws/v2/onHold/cancelHoldCycle",
  ON_HOLD_REQUEST_RELEASE_CYCLE: "/ws/v2/onHold/requestReleaseHoldCycle",
  ON_HOLD_RELEASE_CYCLE: "/ws/v2/onHold/releaseHoldCycle",
  ON_HOLD_REJECT_CYCLE: "/ws/v2/onHold/rejectHoldCycle",
  
  REJECT_ON_HOLD_TRANSACTION: "/ws/v2/onHold/rejectHoldTransactions",
  REJECT_ON_HOLD_TRANSACTION_TYPE: "/ws/v2/onHold/rejectHoldTransactionType",
  REJECT_ON_HOLD_CYCLE: "/ws/v2/onHold/rejectHoldCycle",
  REJECT_ON_HOLD_COMPANY: "/ws/v2/onHold/rejectHoldCompany",

  GET_HOLD_PAYOUT_SUMMARY_TRANSACTION_TYPE: "getHoldPayoutSummaryTransType",
  GET_HOLD_PAYOUT_SUMMARY_DEALER: "getHoldPayoutSummaryDealer",
  GET_HOLD_PAYOUT_TRANSACTIONS: "getHoldPayoutTransactions",

  GET_EARMARKS_DETAILS: "getEarmarkDetails",
  GET_WITHHOLDING_DETAILS: "/ws/v1/withholdingtax/getWithHoldingTaxDtls",
  GET_FREEZE_ACCOUNT_DEALER_LIST: "addDealerForFreezeAccount",
  ALL_ACCOUNTS_EARMARK_DETAILS: "allAccountsEarmarkDetails",
  EARMARK_FILTER_DETAILS: "earmarkFilterDetails",
  ADD_EARMARK_DETAILS: "addEarMarkDetails",
  EARMARK_DETAILS_UPDATE: "earmarkDetailsUpdate",
  EARMARK_DETAILS_DELETION: "earmarkDetailsDeletion",
  EARMARK_DETAILS_AUDIT: "earmarkDetailsAudit",

  EARMARK_DETAILS_SUMMARY: "earmarkDetailsSummary",
  EARMARK_ACTIVITY_DETAILS_AUDIT: "earmarkActivityDetailsAudit",
  EARMARK_REPORT_DOWNLOAD: "earmarkReportDownload",
  GET_FREEZE_ACCOUNT_DETAILS: "/freezeAccount/getFreezeAccountDetails",
  GET_FREEZE_ACCOUNT_ACTIVITY_DETAILS: "/freezeAccount/getFreezeAccountDetailsActivity",
  GET_DEBIT_CREDIT_DETAILS: "/debitCredit/getDebitCreditDetails",

  GET_DEBIT_CREDIT__ACTIVITY_DETAILS: "/debitCredit/getDebitCreditDetails",
  GET_LIST_OF_DEALERS_FOR_CREDIT_DEBIT: "/debitCredit/getDealersList",
  GET_LIST_OF_DESCRIPTION_DROPDOWN_CREDIT_DEBIT: "/debitCredit/getAdjustmentDescDropdowns",
  ADD_NEW_ADJUSTMENT_CREDIT_DEBIT: "/debitCredit/addDebitCreditDetails",
  UPDATE_ADJUSTMENT_CREDIT_DEBIT: "/debitCredit/updateDebitCreditDetails",
  FREEZE_ACCOUNT_REPORT_DOWNLOAD: "freezeAccountReportDownload",
  CREDIT_DEBIT_REPORT_DOWNLOAD: "debitCreditReportDownload",
  
  GET_WITHHOLDING_TAX_DETAILS: "/ws/v1/withholdingtax/getSummaryOfWithHoldingTaxDtls",
  WITHHOLDING_TAX_REPORT_DOWNLOAD: "/rp/withholdingtax/collection/whtReportDownload",

  GET_PAYOUT_DATES_DETAILS: "/ws/v1/payoutdates/getPayoutdates",
  UPDATE_PAYOUT_DATES_DETAILS: "/ws/v1/payoutdates/payoutdatesUpdate",
  GET_PAYOUT_DATES_ACTIVITY_DETAILS: "/ws/v1/payoutdates/payoutdatesActivities",
  GET_PAYOUT_DATES_ACTIVITY_ROW_DETAILS: "/ws/v1/payoutdates/payoutdatesActivityDetails",
  CANCEL_ON_HOLD_COMPANY: "/ws/v1/onHold/cancelHoldCompany",
  GET_EXCLUSION_ITEMS_DETAILS: "/exclusion/exclusionTransactionTypeList",
  REMOVE_EXCLUSION_ITEMS: "/exclusion/removeExclusion",
  GET_EXCLUSION_ACTIVITY_DETAILS: "/exclusion/exclusionActivityList",

  ADD_NEW_EXCLUSION: "/ws/v1/exclusion/addExclusion",

  EXCLUSION_DEALER_HEADER_SUMMARY: "/ws/v1/exclusion/exclusionSumDealersList",
  EXCLUSION_DEALER_DATA_LIST: "/ws/v1/exclusion/exclusionDealersList",

  EXCLUSION_TRANSACTION_HEADER_SUMMARY: "/ws/v1/exclusion/exclusionSumTransactionsList",
  EXCLUSION_TRANSACTION_DATA_LIST: "/ws/v1/exclusion/exclusionTransactionsList",
  REMOVED_EXCLUSION_FOR_ADJUSTMENT: "/ws/v1/exclusion/removeExclusionForAdjustment",
  ADD_ADJUSTMENT_TO_EXCLUSION: "/exclusion/removeExclusionSubmitAdjustments",
  EXCLUSION_FILE_READ: "/ws/v1/file/fileRead",

  
  // cash out limits
  GET_CASH_OUT_LIMIT_DETAILS: "/cashoutlimit/getCashOutLimitDetails",
  GET_CASH_OUT_GLOBAL_LIMIT_DETAILS: "/cashoutlimit/getCashOutGlobalLimitDetails",
  GET_CASH_OUT_ACTIVITY_DETAILS: "/cashoutlimit/getActivityDetails",
  GET_CASH_OUT_TIMELINE_DETAILS: "/cashoutlimit/getTimelineDetails",

  GET_CASH_OUT_GLOBAL_TIMELINE_DETAILS: "/cashoutlimit/getGlobalTimeLineDetails",
  GET_CASH_OUT_TIER_VALUE: "/cashoutlimit/getTierValue",

  APPLY_GLOBAL_SETTING_FOR_DEALER: "/cashoutlimit/configureCashOutGlobalSettingForSelectedDealer",
  SAVE_CASH_OUT_LIMIT_FOR_DEALER: "/cashoutlimit/configureCashOutLimitForSelectedDealer",

  SAVE_GLOBAL_CASH_OUT_LIMIT: "/cashoutlimit/configureCashOutGlobalSetting",

  CASH_OUT_LIMIT_REPORT_DOWNLOAD: "cashOutLimitReportDownload",
  GET_COMPANY_DETAILS_LIST: "/ws/v1/reports/getCompanyDetails",
  GET_PAYOUT_CYCLE_DATES: "/ws/v1/reports/getPayoutCycleDates",
  GET_REPORT_DETAILS_LIST: "/ws/v1/reports/getReportDetails",
  GET_BRANCH_DETAILS_LIST: "/ws/v1/reports/getBranchDetails",
  GET_DATE_DROPDOWN_LIST: "/ws/v1/reports/getPayoutNameList",
  GET_PAYOUT_REPORT_NAME: "/ws/v1/reports/getPayoutReportNames",
  REPORT_MODULE_FILE_DOWNLOAD: "/rp/report/collection/downloadReport",
  GET_REPORT_NAMES_LIST: "/ws/v1/reports/getPayoutReportNames",
  INITIATE_REPORT_PREPRATION: "/rp/excelTab/collection/excelTabReportDownloadService",
  REPORT_READY_TO_DOWNLOAD: "/rp/excelTab/collection/reportDownload",


  ALL_ACCOUNTS_CREDIT_DEBIT_DETAILS_SEARCH: "/ws/v1/debitCredit/getDealersList",
  CHANGE_PASSWORD: "/ws/v1/user/changePassword",
  FORGOT_PASSWORD: "/ws/v1/user/forgotPassword",
  RESET_PASSWORD: "/ws/v1/user/resetPassword",
  GET_HOLD_PAYOUT_COUNT_SUMMARY: "/ws/v2/onHold/getHoldPayoutCountSummary",

};

export const ApiErrorCode = {
  SESSION_ID_NOT_FOUND: "ERR-YESSHOPADMINWEB1035",
  SESSION_EXPIRED: "ERR-YESSHOPADMINWEB103",
  UNABLE_TO_PROCESS_ERROR: "ERR-YESSHOPADMINWEB100",
  ERROR_OCCURED_DURING_REQUEST: "ERR-YESSHOPADMINWEB1034",
  NETWORK_ERROR:"Network Error"
};
